import { stack } from '@styled-system/patterns';
import { type FC } from 'react';

import { usePaymentTabData } from '@/features/settings/hooks';
import { Message } from '@/shared/components/ui/Message';

import { SettingsButtonItem } from './SettingsButtonItem';

export const PaymentTab: FC = () => {
  const { showCancelButton, cancelAt, handlePaymentMethodAndInvoices, handleSubscriptionCancel } = usePaymentTabData();

  const handlePaymentClick = async () => {
    try {
      await handlePaymentMethodAndInvoices();
    } catch (error) {
      console.error('Payment method error:', error);
    }
  };

  const handleCancelClick = async () => {
    try {
      await handleSubscriptionCancel();
    } catch (error) {
      console.error('Cancel subscription error:', error);
    }
  };

  const containerStyles = stack({
    direction: 'column',
    gap: 'md',
  });

  return (
    <div className={containerStyles}>
      <SettingsButtonItem
        label="Moyen de paiement & Factures"
        buttonText="Gérer"
        handleClick={handlePaymentClick}
        variant="primary"
      />

      {showCancelButton ? (
        <SettingsButtonItem
          label="Annuler son abonnement"
          buttonText="Annuler"
          handleClick={handleCancelClick}
          variant="danger"
        />
      ) : cancelAt ? (
        <Message type="info" bordered textColor="font.primary">
          {cancelAt.getTime() > Date.now() ? 'Votre abonnement prendra fin le' : 'Votre abonnement a été annulé le'}{' '}
          {cancelAt.toLocaleDateString()}
        </Message>
      ) : null}
    </div>
  );
};
